<template>
  <div id="app">
    <Header></Header>

    <router-view/>
    <Footer></Footer>
    <FDialog v-if="dialogShow" :config="dialogConfig"></FDialog>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import FDialog from '@/components/FDialog'

  export default {
    name: 'App',
    data () {
      return {
        dialogConfig: this.$store.getters.getDialogConfig
        // dialog默认为0
        , dialogShow: 0
        // 页面类型 0为注册 1为忘记密码
        , pageType: 0
      }
    },
    methods: {},
    computed: {},
    components: {
      Header: Header,
      Footer: Footer,
      FDialog: FDialog
    }
    , watch: {
      'dialogConfig.ifShow': function (newData, lastData) {
        var that = this
        if (newData == 0) {
          setTimeout(function () {
            that.dialogShow = 0
          }, 300)
        } else {
          that.dialogShow = 1
        }
      }
      , created () {
        // 如果是空的进来跳转到
        if (this.$route){

        }
      }
    }
  }
</script>

<style>
  #app {
    width: 100%;
    height: 100%;
    font-family: MicrosoftYaHei;
    font-size: 0;
    background: #F5F5F5;
    margin: 0;
    padding: 0;
    transition: all .3s;
    overflow: auto;
  }

  a {
    cursor: pointer;
  }

  /*:before, :after {*/
    /*display: none;*/
    /*content: '';*/
  /*}*/

  .none {
    display: none !important;
  }

  .content {
    width: 100%;
    height: auto !important;
    min-height: calc(100% - 253px);
    max-width: 1200px;
    box-sizing: border-box;
    margin: 8px auto;
    background: #ffffff;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue